import React, { useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, Image, Toast } from "antd-mobile";
import API from "@/api";
import useCustomTranslation from "@/hooks/useTranslation";
import { AgentListData } from "@/api/type";
import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";

const ApplyProportion: React.FC<{
	data: AgentListData;
	onVisiblePopup: (visible: boolean) => void;
}> = ({ data, onVisiblePopup }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { userInfo } = useSelector((state: RootState) => state.auth);
	const [scaleValue, setScaleValue] = useState(+data.rolling || 0);

	const handleIncrementDecrement = (amount: number) => {
		setScaleValue((prevValue) => {
			const newValue =
				(Math.round(prevValue * 100) + Math.round(amount * 100)) / 100;
			return Math.max(0, Math.min(userInfo?.rolling ?? 100, newValue));
		});
	};
	const toFixedString = (num: number) => {
		return typeof num === "number" ? num.toFixed(2) : "0.00";
	};

	const postUserAgentInviteRemakeHandle = async () => {
		try {
			const params: any = {
				id: data.uid,
				rolling: scaleValue,
			};
			const result: any = await API.members.postUserAgentInviteRemake(
				params
			);
			if (result?.code === 0) {
				Toast.show({
					content: t("UpdateCompleted"),
					position: "top",
				});
				data.rolling = toFixedString(scaleValue);
				setScaleValue(0);
			}
		} catch (error) {
			console.log("---postUserAgentInviteRemakeHandle--:", error);
		} finally {
			onVisiblePopup(false);
		}
	};

	const onSubmit = () => {
		// 不判相同
		postUserAgentInviteRemakeHandle();
	};
	return (
		<div className={classes.applyProportionWrap}>
			<h2>{t("ApplyProportion")}</h2>
			<div className="inputWrap">
				<Image
					onClick={() => handleIncrementDecrement(-0.1)}
					src={require("@/assets/images/icons/sub.png")}
					width={32}
					height={32}
				/>
				<div className="inputBox">
					<span>{scaleValue}%</span>
				</div>
				<Image
					onClick={() => handleIncrementDecrement(0.1)}
					src={require("@/assets/images/icons/add.png")}
					width={32}
					height={32}
				/>
			</div>
			<Button
				onClick={onSubmit}
				block
				shape="rounded"
				style={{
					height: pxToRem(50),
					fontSize: pxToRem(16),
					fontWeight: "700",
					"--border-width": "0",
					"--text-color": "#FFFFFF",
					background:
						" linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
				}}
			>
				{t("Cofirm")}
			</Button>
		</div>
	);
};

export default ApplyProportion;

const useStyles = createUseStyles({
	applyProportionWrap: {
		position: "relative",
		zIndex: 9999,
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(38),
			top: pxToRem(20),
		},
		background: "linear-gradient(to bottom right, #181B24 0, #232C48 100%)",
		"& h2": {
			color: "#FFFBEE",
			fontSize: pxToRem(18),
			fontWeight: "500",
			lineHeight: pxToRem(28),
		},
		"& .inputWrap": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			padding: {
				top: pxToRem(15),
				bottom: pxToRem(45),
				left: pxToRem(34),
				right: pxToRem(34),
			},
			"& .inputBox": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: pxToRem(50),
				width: pxToRem(154),
				color: "#FFFFFF",
				fontSize: pxToRem(18),
				fontWeight: pxToRem(500),
				borderRadius: pxToRem(8),
				margin: {
					left: pxToRem(14),
					right: pxToRem(14),
				},
				border: "1px solid #4C66C7",
				backgroundColor: "#181A22",
			},
		},
	},
});
